import { LOGGER_REGISTRY } from './LOGGER_REGISTRY';
import { TELEHEALTH_REGISTRY } from './TELEHEALTH_REGISTRY';

export const RUNTIME_REGISTRIES = {
  logger: LOGGER_REGISTRY,
  telehealth: TELEHEALTH_REGISTRY,
};
